

import React, {useState} from 'react'
import { useDispatch, useSelector } from "react-redux";
import {downloadReport} from "../../Redux/Actions"

function BookingDetails({ booking,token }) {

    // const [usertoken,setUserToken] = useState()
    // setUserToken(token)

    const downloadReportResponse = useSelector((state) => state.downloadReportResponse);
    console.log(downloadReportResponse);
    
    const dispatch = useDispatch()

    const handleClick = () => {
    console.log(booking.pk,token)
    dispatch(downloadReport(booking.pk,token))
}
    return (
        <div>
            <h2>{booking.booking_date}</h2>
            <button onClick= {handleClick}>Download Report</button>
        </div>
    )
}

export default BookingDetails

